import React, {useEffect, useState, useRef, useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import IkeaOffice from "../../../components/ConfirmBox";
import "./style.scss";

import TabsMenu from "../../../components/TabsMenu";
// import Options from "../../../components/Options";
import Loader from "../../../components/Loader";
import "../../../components/Loader/style.scss";
import {
  // dataDashboard,
  getCountrySet,
} from "../../../util";
import {
  // processDataFromArrayOfObject,
  // processStoresData,
  filteredStore,
} from "../storeUtil";
import BlockBtn from "../../../components/BlockBtn";
import {API, processApiResponse} from "../../../services/HttpHandler";
import {
  setCustomerSlotDetails,
  getCustomerSlotDetails,
} from "../../../services/SessionStorage";
import {ADOBEDTM_PAGE_NAME} from "../../../constants";
import SlotBookingError from "../../SlotBooked/SlotBookingError";
import {StepperWrapper} from "../../../components/StepperWrapper";
import Dropdown from "../../../components/Dropdown/Dropdown";
import {calculateDropdownHeight} from "../../../util/common";

import config from "../../../../config";

const OfficeSelect = () => {
  // const [allCountryData, setAllCountryData] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState();
  const [allLocations, setAllLocations] = useState([]);
  const [location, setLocation] = useState();
  const [bu, setBu] = useState();
  const [storeListAllDetail, setStoreListAllDetail] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [selectedStore, setSelectedStore] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [openIkeaOfficeConfirm, setOfficeBooking] = useState(false);
  const navigate = useRef(useNavigate());
  const {t} = useTranslation();
  const updatedCustomerSlotDetails = useRef(getCustomerSlotDetails());
  const [buList, setBuList] = useState(
    updatedCustomerSlotDetails.current.buList
  );
  const [countryByLocation, setCountryByLocation] = useState();
  const [buByLocation, setBUByLocation] = useState();
  const [dropdownMaxHeight, setDropdownMaxHeight] = useState(100);
  const [showText, setShowText] = useState(false);

  const fetchAllCountryList = useCallback(async (isOffice) => {
    try {
      setLoading(true);
      const prepareURL = `?office=${isOffice}`;
      let response = await API.get(config.endPoints.filters + prepareURL);
      response = await processApiResponse(response);
      const {bu, countries, countryByLocation, locations, subLocations} =
        getCountrySet(response);
      setCountryList(countries);
      setCountryByLocation(countryByLocation);
      setBUByLocation(bu);
      // setAllCountryData([...response.countries]);
      // const countryNames = processDataFromArrayOfObject(
      //   response.countries,
      //   "code"
      // );
      // setCountryList([...countryNames]);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    async function checkValidFilter() {
      fetchAllCountryList(updatedCustomerSlotDetails.current.isOffice);
    }
    checkValidFilter();
  }, [fetchAllCountryList]);

  useEffect(() => {
    setShowText(false);
    if (countryByLocation && countryList?.length && selectedCountry) {
      const locationList = countryByLocation[selectedCountry.value];
      setAllLocations(locationList);
      // const filteredCountry = allCountryData.filter((data) => {
      //   return data.code === selectedCountry.value;
      // });
      // const locationList = filteredCountry[0]["locations"];
      // const locations = processDataFromArrayOfObject(locationList, "name");
      // setAllLocations([...locations]);
      setLocation();
      setBuList([]);
      setBu();
      setStoreList([]);
      setSelectedStore();
    }
  }, [selectedCountry]);

  useEffect(() => {
    setShowText(false);
    if (
      countryByLocation &&
      countryList?.length &&
      selectedCountry &&
      allLocations?.length &&
      location
    ) {
      // const locationList = countryByLocation[selectedCountry.value];
      // const filteredCountry = allCountryData.filter((data) => {
      //   return data.code === selectedCountry;
      // });
      // const locationList = filteredCountry[0]["locations"];
      // const filteredLocation = locationList.filter((tempLocation) => {
      //   return tempLocation.name === location.value;
      // });
      if (location?.value) {
        // const businessUnits = filteredLocation[0]["businessUnits"];
        const buToSet = buByLocation[location.value];
        setBuList([...buToSet]);
        setBu();
        setStoreList([]);
        setSelectedStore();

        if (
          selectedCountry?.value === "CL" &&
          location?.value === "Metropolitana de Santiago"
        ) {
          setShowText(true);
        }
      }
    }
  }, [location]);

  const isStoreDropdownEnable = !!selectedCountry && !!location && !!bu;

  useEffect(() => {
    if (
      countryByLocation &&
      countryList?.length &&
      selectedCountry &&
      allLocations?.length &&
      location &&
      buList?.length &&
      bu
    ) {
      setSelectedStore();
      let sessionData = getCustomerSlotDetails();
      let tempData = {...sessionData};
      tempData["buList"] = [...buList];
      tempData["bu"] = bu;
      setCustomerSlotDetails({
        ...updatedCustomerSlotDetails.current,
        ...tempData,
      });
      if (bu) fetchStores(selectedCountry.value, location.value, bu.value);
    }
  }, [bu]);

  const fetchStores = useCallback(async (selectedCountry, location, bu) => {
    const {isOffice} = updatedCustomerSlotDetails.current;
    try {
      setError("");
      const prepareURL = `?country=${selectedCountry}&location=${location}&businessunit=${bu}&office=${isOffice}`;
      let response = await API.get(config.endPoints.stores + prepareURL);
      response = await processApiResponse(response);
      setStoreListAllDetail([...response[0]["stores"]]);
      const storeListToSet = response[0]["stores"]?.map((store) => {
        return {value: store.uuid, label: store.storeName};
      });
      setStoreList(storeListToSet);
      // const filteredStores = processStoresData(response[0]["stores"]);
      // setStoreList([...filteredStores]);
      return true;
    } catch (error) {
      setError(t("error.failedToFetchStores"));
      return false;
    } finally {
    }
  }, []);

  // useEffect(() => {
  //   let timer = setTimeout(() => {
  //     // for data dashboard
  //     const URL = window.location.href.split("/")[2];
  //     const officeApp = updatedCustomerSlotDetails.current.isOffice
  //       ? URL + "/office"
  //       : URL + "/app";
  //     const datamap = new Map();
  //     datamap.set("pageName", ADOBEDTM_PAGE_NAME.CT_Store_Selection);
  //     datamap.set("prop1", URL);
  //     datamap.set("prop2", officeApp);
  //     dataDashboard(datamap);
  //     return () => {
  //       clearTimeout(timer);
  //     };
  //   }, 1000);
  // }, []);

  const makeBooking = () => {
    const _store_ = filteredStore(storeListAllDetail, selectedStore.label);
    const selectedStoreDetail = {..._store_[0]};
    if (selectedStoreDetail.stdCode) {
      selectedStoreDetail.callCode = "+" + selectedStoreDetail.stdCode + " ";
    }

    selectedStoreDetail.location = location?.label;
    updatedCustomerSlotDetails.current.currentBookingDetails = {
      selectedStore: selectedStoreDetail,
    };
    updatedCustomerSlotDetails.current.currentBookingDetails.bu = bu?.label;
    updatedCustomerSlotDetails.current.country = selectedCountry?.label;
    if (selectedStoreDetail.mallId) {
      let selectedMallStores = {};
      selectedMallStores.uuid = selectedStoreDetail.mallId;
      updatedCustomerSlotDetails.current.selectedMallStores = [
        selectedMallStores,
      ];
    } else {
      updatedCustomerSlotDetails.current.selectedMallStores = [];
    }
    setCustomerSlotDetails(updatedCustomerSlotDetails.current);
    // const datamap = new Map();
    // datamap.set("events", "event16=1");
    // datamap.set("eVar8", bu);
    // datamap.set("eVar5", selectedStoreDetail.storeName);
    // datamap.set("eVar9", location);
    // dataDashboard(datamap);
    if (selectedCountry?.value === "CL") {
      // commented to hide office questions
      // navigate.current("/customer/officeQuestions");
      navigate.current("/customer/bookslot");
    } else navigate.current("/customer/bookslot");
  };

  const handleClick = () => {
    setOfficeBooking(true);
    if (bu.label === "IKEA - Oficinas") {
      setOfficeBooking(true);
    } else {
      makeBooking();
    }
  };

  useEffect(() => {
    const dropDownMenuHeight = calculateDropdownHeight(
      "office-store-main-wrap"
    );
    setDropdownMaxHeight(dropDownMenuHeight);
  }, []);

  return loading ? (
    <div className="loader-container">
      <Loader />
    </div>
  ) : (
    <>
      <TabsMenu path="SelectStore" />
      <div className="office-store-main-container">
        {!error ? (
          <React.Fragment>
            <div className="office-store-main-wrap">
              <StepperWrapper current={0} />
              <div>
                <div className="location-label-text">Ubicación</div>
                <div className="selection-label-text">
                  Selecciona donde quieres reservar
                </div>
              </div>
              {openIkeaOfficeConfirm && (
                <IkeaOffice
                  title={t("RTE.office.booking.title")}
                  text={[t("RTE.office.booking.text")]}
                  close={() => setOfficeBooking(false)}
                  performAction={() => makeBooking()}
                />
              )}
              <div className="office-content-wrapper">
                <div className="office-content-container">
                  <div className="office-wrap">
                    <label className="office-select-label-text">País</label>
                    <Dropdown
                      options={countryList}
                      onChange={(data) => setSelectedCountry(data.option)}
                      value={selectedCountry ? selectedCountry : null}
                      placeholder="Selecciona..."
                      size="md"
                    />
                  </div>
                  <div className="office-wrap">
                    <label className="office-select-label-text">Ciudad</label>
                    <Dropdown
                      options={allLocations}
                      onChange={(data) => setLocation(data.option)}
                      value={location ? location : null}
                      placeholder="Selecciona..."
                      size="md"
                    />
                  </div>
                </div>
                <div className="office-content-container">
                  <div className="office-wrap">
                    <label className="office-select-label-text">
                      Unidad de negocio
                    </label>
                    <Dropdown
                      options={buList}
                      onChange={(data) => setBu(data.option)}
                      value={bu ? bu : null}
                      placeholder="Selecciona..."
                      size="md"
                      scrollableHeightinPixel={dropdownMaxHeight}
                      from="office_bu"
                      // isOffice={updatedCustomerSlotDetails.current.isOffice}
                    />
                    {showText && (
                      <div className="cowork-message">
                        <sup>*</sup>
                        {t("coworkMessage")}
                      </div>
                    )}
                  </div>
                  <div className="office-wrap">
                    {isStoreDropdownEnable && (
                      <>
                        <label className="office-select-label-text">
                          Espacio
                        </label>
                        <Dropdown
                          options={storeList}
                          onChange={(data) => setSelectedStore(data.option)}
                          value={selectedStore ? selectedStore : null}
                          placeholder="Selecciona..."
                          size="md"
                          // isOffice={updatedCustomerSlotDetails.current.isOffice}
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-div">
              <BlockBtn
                name={t("proceed.label")}
                handleClick={handleClick}
                disabled={!selectedStore}
              />
            </div>
          </React.Fragment>
        ) : (
          <SlotBookingError error={error} />
        )}
      </div>
    </>
  );
};

export default OfficeSelect;
